import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Instagram } from "lucide-react";

const navLinks = [
  { label: "Producto", href: "#producto" },
  { label: "Experiencia", href: "#experiencia" },
  { label: "Bienestar", href: "#bienestar" },
  { label: "Colecciones", href: "#colecciones" },
  { label: "FAQ", href: "#faq" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="header-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#050505]/90 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        <a href="#hero" className="flex items-center gap-2" data-testid="header-logo">
          <span className="font-serif text-2xl md:text-3xl tracking-tight text-[#D4AF37]">
            Serena
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-10" data-testid="desktop-nav">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-xs uppercase tracking-[0.2em] text-white/60 hover:text-[#D4AF37] transition-colors duration-300"
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://www.instagram.com/serena_candlesmx"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram de Serena"
            className="text-white/60 hover:text-[#D4AF37] transition-colors duration-300 ml-4"
          >
            <Instagram size={18} />
          </a>
          <a
            href="#waitlist"
            className="bg-[#D4AF37] text-black px-6 py-2 text-xs uppercase tracking-wider font-medium hover:bg-[#C5A059] transition-all duration-300"
            data-testid="header-cta"
          >
            Unirme
          </a>
        </nav>

        {/* Mobile hamburger */}
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white/80 hover:text-[#D4AF37] transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-[#0A0A0A] border-t border-white/5 overflow-hidden"
            data-testid="mobile-menu"
          >
            <nav className="flex flex-col px-6 py-6 gap-5">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setMobileOpen(false)}
                  className="text-sm uppercase tracking-widest text-white/60 hover:text-[#D4AF37] transition-colors"
                >
                  {link.label}
                </a>
              ))}
              <a
                href="https://www.instagram.com/serena_candlesmx"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setMobileOpen(false)}
                className="flex items-center gap-2 text-sm uppercase tracking-widest text-white/60 hover:text-[#D4AF37] transition-colors mt-2"
              >
                <Instagram size={18} />
                <span>Instagram</span>
              </a>
              <a
                href="#waitlist"
                onClick={() => setMobileOpen(false)}
                className="bg-[#D4AF37] text-black px-6 py-3 text-xs uppercase tracking-wider font-medium text-center hover:bg-[#C5A059] transition-all duration-300 mt-2"
                data-testid="mobile-cta"
              >
                Unirme a la Lista
              </a>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
